import { useQuery } from "@apollo/client";
import { AssortmentChildrenQuery } from "../queries/assortmentQueries";

const useAssortmentChildren = ({ assortmentId }: { assortmentId: string }) => {
  const {
    data: { assortment } = {},
    previousData: { assortment: previousAssortment } = {},
    ...rest
  } = useQuery(AssortmentChildrenQuery, {
    notifyOnNetworkStatusChange: true,
    returnPartialData: true,
    variables: {
      assortmentId,
    },
    skip: !assortmentId,
  });

  return {
    assortment: assortment || previousAssortment,
    ...rest,
  };
};

export default useAssortmentChildren;
